module.exports = __webpack_public_path__ + "static/genuss-mobile-420bc5537befd12595769ac0da5728d2.jpg";